































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"

export interface BaseSheet{
  nendo: string
  month: string
  times: string
  grade: string

}

export interface Data {
  base_sheet_id: string
  baseSheet: BaseSheet | null
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    const state = reactive<Data>({
      base_sheet_id: null,
      baseSheet: null,
      errors: []
    });

    const create = async () => {

      if(!window.confirm("ダミー試験情報を作成します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      
      await http.post(`/api/dummy_base_sheet_edit/create_dummy_data`, {base_sheet: state.baseSheet}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.baseSheet = {nendo: "", month: "", grade: "", times: ""};
    });

    return {
      ...toRefs(state),
      create,
    }
  },
})
